module.exports = __webpack_public_path__ + "static/img/goldmember.9c4e5c6.png";